// extracted by mini-css-extract-plugin
export default {"popUpWrap":"styles_popUpWrap__wXfTE","popUp":"styles_popUp__6I+nW","popUpOpen":"styles_popUpOpen__FGvC+"};